<!--
TODO тут какая-то ошибка связана с v-model
-->
<template>
    <input
        v-model="maskedValue"
        v-maska="bindedObject"
        data-maska="9 99#.##"
        data-maska-tokens="9:[0-9]:repeated"
        data-maska-reversed
        @maska="$emit('update:value', (maskedValue))"
        class="money-inp"
    >
</template>

<script>
import { vMaska } from "maska";

export default {
    name: 'Money input',
    directives: { maska: vMaska },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    emits: ['update:value'],
    data () {
        return {
            maskedValue: this.value,
            bindedObject: {
                masked: "",
                unmasked: "",
                completed: false,
            },
        }
    }
}
</script>

<style>

</style>